<template>
  <div class="page page--fill">
    <data-list
      v-if="$env.billing"
      title="Factures"
      client="billing"
      resource="invoices"
      :columns="columns"
      :filters="filters">
      <template #ref="{ item }">
        <span class="cell-mono">{{ item.ref }}</span>
      </template>
      <template #account="{ item }">
        <router-link
          v-if="item.account"
          class="cell-link"
          :to="{ name: 'accountVue', params: { id: item.account.external_pk } }">
          {{ item.account.name }}
        </router-link>
      </template>
      <template #file_path="{ item }">
        <v-btn
          v-if="item.file_path"
          :href="item.file_path"
          target="_blank"
          text
          small
          color="primary"
          @click.stop>
          <v-icon
            left
            small>
            mdi-download
          </v-icon>
          PDF
        </v-btn>
      </template>
    </data-list>
    <billing-unavailable v-else />
  </div>
</template>

<script>
  import DataList from '../components/DataList'
  import BillingUnavailable from '../components/BillingUnavailable'
  import { formatDate, monthRange } from '../labels'

  export default {
    name: 'BillsList',
    components: { DataList, BillingUnavailable },
    data () {
      return {
        columns: [
          { key: 'ref', label: 'Référence', width: 180 },
          { key: 'account', label: 'Compte' },
          { key: 'date', label: 'Date', width: 120, format: formatDate },
          { key: 'file_path', label: '', width: 100, align: 'end' }
        ],
        filters: [
          { key: 'month', type: 'month', label: 'Mois', toParams: monthRange }
        ]
      }
    }
  }
</script>
